import React from 'react';
import PropTypes from 'prop-types';

import MobileNavList from './MobileNavList';
import MobileNavMenuListItem from './MobileNavMenuListItem';
import Group from './MobileNavLinkGroup';
import { HeadingStyles } from './MobileNavMenuHeadingStyles';

const MobileNavMenuMultipleLinks = ({
  title,
  links,
  analytics,
  onNavListItemClick,
}) => (
  <Group>
    <div className={HeadingStyles}>{title}</div>
    <MobileNavList>
      {links.map((link) => (
        <MobileNavMenuListItem
          key={link.url}
          clickHandler={(e) => onNavListItemClick(e, { analytics, ...link })}
          {...link}
        />
      ))}
    </MobileNavList>
  </Group>
);

MobileNavMenuMultipleLinks.defaultProps = {
  title: '',
  onNavListItemClick: null,
  analytics: null,
};

MobileNavMenuMultipleLinks.propTypes = {
  onNavListItemClick: PropTypes.func,
  title: PropTypes.string,
  analytics: PropTypes.shape({
    event: PropTypes.string,
    data: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  }),
  links: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string,
      label: PropTypes.string,
      clickAction: PropTypes.string,
    }),
  ).isRequired,
};

export default MobileNavMenuMultipleLinks;
